import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebClientService } from '../../services/webclient-settings.service';
import { LanguageService } from '../../services/language.service';
import { AuthService } from '../../services/auth.service';
import { Router } from "@angular/router";
/**
 * VerifyComponent
 */
let VerifyComponent = class VerifyComponent {
    constructor(httpClient, sanitizer, themeService, webSettingsService, languageService, auth, router) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.webSettingsService = webSettingsService;
        this.languageService = languageService;
        this.auth = auth;
        this.router = router;
        this.token = '';
        this.userData = {};
        this.successColor = '';
        this.popupColor = '';
        this.backColor = '';
        this.accentColor = '';
        this.secondColor = '';
        this.inputTextColor = '';
        this.mainColor = '';
        this.errorColor = '';
        this.mobileValidated = false;
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.addressVerified = true;
        this.isCompanyUser = false;
        this.countries = [];
        this.address = {};
        this.docmentationVerified = false;
        this.addressValidatedBreadCrumbClass = '';
        this.mobileValidatedBreadCrumbClass = '';
        this.personalValidatedBreadCrumbClass = '';
        this.documentValidatedBreadCrumbClass = '';
        this.adressVerificationTitle = '';
        this.personalyVerifiBreadCrumbClass = '';
        this.data = {};
        this.documentVerifiedBreadCrumbClass = '';
        this.userdocumentVerifiedBreadCrumbClass = '';
        this.textColor = '';
        this.keyword = 'output';
        this.loadingSpinner = true;
        this.onfidoLoadingSpinner = false;
        this.linkColor = '';
        this.dropdownBackground = '';
        this.documents_submitted = false;
        this.user_documents_submitted = false;
        this.user_document_verification_upload = false;
        this.styles = {};
        this.latitude = 44.4419211;
        this.showNONEUAttribute = true;
        this.tradeCoreUserId = [];
        this.tradeCoreApplicantId = [];
        this.tradeCoreCheckId = [];
        this.tradeCoreCheckStatus = [];
        this.tradeCoreCheckResult = [];
        this.tradeCoreOnfidoSDKToken = [];
        this.tradeCoreCreateKycUserAttempt = [];
        this.blinkingEnabled = false;
        this.blinkingAvailable = false;
        this.generalDataVerified = false;
        this.fillGeneralData = false;
        this.blinkingClient = false;
        this.finishedBlinkingPhaseTwo = false;
        this.verificationDocumentsExpired = false;
        this.riskLevelHigh = 'High';
        this.isBlinkingProcessContinued = false;
        this.eligibleForVideoId = false;
        this.goToPersonalVerification = false;
        this.title = 'ECD maps';
        this.languageService.getChosenLanguage().subscribe((lang) => {
            this.lang = lang ? lang : 'en';
        });
        this.themeService.getTheme().subscribe((data) => {
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.popupColor = this.themeService.getStyleAttribute('pop_up_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.dropdownBackground = this.themeService.getStyleAttribute('currency_ring_one_color');
        });
    }
    ngOnInit() {
        this.webSettingsService.getSettings().subscribe((data) => {
            this.showNONEUAttribute = this.webSettingsService.getWebSetting('APP_REGION') != 'EU';
            this.showPersonalVerification = this.webSettingsService.applySettings('VERIFICATIONS.PERSONAL_VERIFICATION');
            this.blinkingEnabled = this.webSettingsService.applySettings('VERIFICATION.BLINKING.ENABLED');
            this.checkBlinkingAvailability();
            this.fetchUser();
        });
    }
    mobilePhoneValidated(event) {
        this.mobileValidated = event;
        this.fetchUser();
    }
    generalUserDataVerified(event) {
        this.generalDataVerified = event;
    }
    goToGeneralData(event) {
        this.fillGeneralData = event;
    }
    setBlinkingAvailable(event) {
        this.blinkingAvailable = event;
    }
    goToBlinkling(event) {
        this.auth.fetchUser().then((result) => {
            window.open(event, '_self');
        });
    }
    setAddressVerified(event) {
        this.addressVerified = event;
        this.fetchUser();
    }
    setDocumentsSubmitted(event) {
        this.user_documents_submitted = event;
    }
    onCompanyDocumentsSubmit(event) {
        this.docmentationVerified = event;
    }
    setGoToPersonalVerification(event) {
        this.goToPersonalVerification = event;
    }
    fetchUser() {
        this.auth.fetchUser().then((result) => {
            this.userData = JSON.parse(localStorage.getItem('user'));
            this.address.userId = this.userData.id;
            this.userType = this.userData.user_type_id.type;
            this.status = this.userData.validated;
            this.mobileValidated = this.userData.mobile_number_validated;
            this.personallyValidated = this.userData.personally_validated;
            this.tradeCoreUserId = this.userData.user_settings.trade_core_user_id;
            this.tradeCoreApplicantId = this.userData.user_settings.applicant_id;
            this.tradeCoreCheckId = this.userData.user_settings.check_id;
            this.tradeCoreCheckStatus = this.userData.user_settings.check_status_verbose_id;
            this.tradeCoreCheckResult = this.userData.user_settings.check_result;
            this.tradeCoreCreateKycUserAttempt = this.userData.user_settings.create_kyc_user_attempt;
            this.tradeCoreOnfidoSDKToken = this.userData.user_settings.sdk_token;
            this.blinkingClient = !!this.userData.user_settings.blinking_url;
            this.finishedBlinkingPhaseTwo = !!this.userData.finished_blinking_phase_two;
            this.verificationDocumentsExpired = this.userData.verification_documents_expired === true;
            this.riskLevel = this.userData.risk_level;
            this.isBlinkingProcessContinued = this.userData.user_settings.is_blinking_process_continued;
            this.eligibleForVideoId = this.userData.user_settings.eligible_for_video_id;
            this.generalDataVerified = this.userData.name && this.userData.date_of_birth;
            const regionNotEU = this.webSettingsService.getWebSetting('APP_REGION') != 'EU';
            this.addressVerified = this.userData.cityId != '' && this.userData.countryId != '' && this.userData.address != '' &&
                this.userData.cityId != null && this.userData.countryId != null && this.userData.address != null &&
                (!this.showNONEUAttribute || this.userData.is_company_user || (this.userData.employmentTypeId != null && this.userData.employmentTypeId != 0)) &&
                (!this.showNONEUAttribute || this.userData.is_company_user || ((this.userData.professionId != -1 && this.userData.professionId != null && this.userData.professionId != 0) ||
                    (this.userData.professionId == -1 && this.userData.otherProfession != '' && this.userData.otherProfession != null))) &&
                (this.userData.poao_id != null && this.userData.poao_id != 0) &&
                (this.showNONEUAttribute || this.userData.is_company_user || ((this.userData.eata_id != -1 && this.userData.eata_id != null && this.userData.eata_id != 0) ||
                    (this.userData.eata_id == -1 && this.userData.otherEata != '' && this.userData.otherEata != null))) &&
                !(this.blinkingEnabled && regionNotEU && !this.personallyValidated);
            this.isCompanyUser = this.userData.is_company_user;
            if (this.isCompanyUser) {
                this.docmentationVerified = this.userData.company.verified;
                this.documents_submitted = this.userData.company.documents_submitted;
            }
            this.user_documents_submitted = this.userData.user_documents_submitted;
            this.user_document_verification_upload = this.userData.user_document_verification_upload == '1';
            this.displayPort = this.userData.validated !== 1;
            this.setVerificationSteps();
            if (this.userData.user_settings.trade_core_user_id != '' && this.userData.user_settings.trade_core_user_id) {
                this.generateSdkToken(this.userData.user_settings.trade_core_user_id);
            }
            this.redirectToPendingScreen();
            this.loadingSpinner = false;
        });
    }
    checkBlinkingAvailability() {
        if (this.blinkingEnabled) {
            this.httpClient.get('blinking/checkAvailability').subscribe((data) => {
                this.blinkingAvailable = true;
            }, (error) => {
                this.blinkingAvailable = false;
            });
        }
    }
    setVerificationSteps() {
        if (this.isCompanyUser) {
            this.adressVerificationTitle = '_PL';
            this.personalyVerifiBreadCrumbClass = 'second-breadcrumb';
            this.documentVerifiedBreadCrumbClass = 'second-breadcrumb';
        }
        else {
            this.adressVerificationTitle = '_FL';
            this.personalyVerifiBreadCrumbClass = 'third-breadcrumb';
            this.documentVerifiedBreadCrumbClass = 'third-breadcrumb';
        }
        this.mobileValidatedBreadCrumbClass = '';
        this.addressValidatedBreadCrumbClass = '';
        this.personalValidatedBreadCrumbClass = '';
        this.documentValidatedBreadCrumbClass = '';
        this.userdocumentVerifiedBreadCrumbClass = '';
        if (!this.mobileValidated) {
            this.mobileValidatedBreadCrumbClass = 'active';
        }
        else {
            this.mobileValidatedBreadCrumbClass = 'finished';
            if (!this.addressVerified && !this.finishedBlinkingPhaseTwo) {
                this.addressValidatedBreadCrumbClass = 'active';
            }
            else {
                this.addressValidatedBreadCrumbClass = 'finished';
                if (this.showPersonalVerification) {
                    if (!this.personallyValidated || (!this.showNONEUAttribute && !this.userData.proof_of_address_submitted)) {
                        this.personalValidatedBreadCrumbClass = 'active';
                    }
                    else {
                        this.personalValidatedBreadCrumbClass = 'finished';
                        if (!this.docmentationVerified && this.isCompanyUser) {
                            this.documentValidatedBreadCrumbClass = 'active';
                        }
                        else {
                            this.documentValidatedBreadCrumbClass = 'finished';
                        }
                    }
                }
                else {
                    if (this.status == 0 || this.status == 2) {
                        this.userdocumentVerifiedBreadCrumbClass = 'active';
                    }
                    else {
                        this.userdocumentVerifiedBreadCrumbClass = 'finished';
                        if (!this.docmentationVerified) {
                            this.documentValidatedBreadCrumbClass = 'active';
                        }
                        else {
                            this.documentValidatedBreadCrumbClass = 'finished';
                        }
                    }
                }
            }
        }
        this.documentValidatedBreadCrumbClass += this.isCompanyUser ? ' pl' : ' fl';
        this.mobileValidatedBreadCrumbClass += this.isCompanyUser ? ' pl' : ' fl';
        this.addressValidatedBreadCrumbClass += this.isCompanyUser ? ' pl' : ' fl';
        this.personalValidatedBreadCrumbClass += this.isCompanyUser ? ' pl' : ' fl';
        this.userdocumentVerifiedBreadCrumbClass += this.isCompanyUser ? ' pl' : ' fl';
    }
    generateSdkToken(tradecoreUserID) {
        this.httpClient.get('user/getsdktoken?tradecoreUserID=' + tradecoreUserID).subscribe((data) => {
            this.tradeCoreOnfidoSDKToken = data;
            if (this.tradeCoreOnfidoSDKToken.message == 'SDK_TOKEN_GENERATED') {
                this.triggerOnfido();
            }
        }, (error) => {
        });
    }
    requestDocumentsCheck(tradeCoreUserId) {
        setTimeout(() => {
            this.onfidoLoadingSpinner = true;
        }, 5000);
        this.httpClient.post('user/requestdocumentcheck', { tradeCoreUserId }).subscribe((data) => {
            this.fetchUser();
            this.onfidoLoadingSpinner = false;
        }, (error) => {
            this.fetchUser();
            this.onfidoLoadingSpinner = false;
        });
    }
    triggerOnfido() {
        if (this.tradeCoreApplicantId) {
            var Onfido = require('onfido-sdk-ui');
            var onfido = {};
            let tradeCoreUserId = this.tradeCoreUserId;
            onfido = Onfido.init({
                token: this.tradeCoreOnfidoSDKToken.token,
                containerId: 'onfido-mount',
                onComplete: data => {
                    this.requestDocumentsCheck(tradeCoreUserId);
                },
                steps: [
                    'welcome',
                    'document',
                    {
                        'type': 'face',
                        options: {
                            title: "Selfy image!",
                            requestedVariant: 'standard',
                        }
                    },
                    {
                        'type': 'face',
                        options: {
                            title: "Video!",
                            requestedVariant: 'video',
                        }
                    },
                    'complete'
                ],
            });
        }
    }
    redirectToPendingScreen() {
        const pendingStatuses = ['TRADE_CORE_CREATE_APPLICANT_FAILED', 'TRADE_CORE_UPDATE_USER_FAILED', 'TRADE_CORE_CREATE_USER_FAILED', 'USER_NOT_FOUND', 'TRADE_CORE_CREATE_IDENTITY_CHECK_FAILED', 'SDK_TOKEN_NOT_GENERATED', 'REQUEST_DOCUMENT_CHECK_FAIL', 'REQUEST_DOCUMENT_CHECK_SUCCESS'];
        if (pendingStatuses.includes(this.userData.user_settings.check_status_verbose_id) && this.userData.proof_of_address_submitted) {
            this.router.navigate(['./pending']);
        }
    }
};
VerifyComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: WebClientService },
    { type: LanguageService },
    { type: AuthService },
    { type: Router }
];
VerifyComponent = __decorate([
    Component({
        selector: 'ecd-verify',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./verify.component.html")).default
    })
], VerifyComponent);
export { VerifyComponent };
